module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "row mr-auto"
  }, [_c('h2', {
    staticClass: "col-12 title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cart.length),
      expression: "!cart.length"
    }],
    staticClass: "col-12"
  }, [_c('i', [_vm._v("Your cart is empty!")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.toCatalog
    }
  }, [_vm._v("Go to catalog")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cart.length),
      expression: "cart.length"
    }],
    staticClass: "col-12 table is-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.cart), function(p) {
    return _c('tr', {
      key: p
    }, [_c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(p.price))])])
  }), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b', [_vm._v("$" + _vm._s(_vm.total))])])])], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "payment-request-button"
    }
  }), _vm._v(" "), (_vm.cart.length > 0 && _vm.noCart != 'yes') ? _c('div', {
    staticClass: "row mr-auto align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-6"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "col-sm-4 col-md-6 btn btn-primary",
    attrs: {
      "tag": "div",
      "to": {
        name: 'checkout',
        params: {
          language: 'en'
        }
      }
    }
  }, [_vm._v("\n      Checkout\n    ")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_c('h6', {}, [_vm._v("Product Name")])]), _vm._v(" "), _c('td', [_c('h6', {}, [_vm._v("Product Price")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2443028e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart.vue
// module id = 322
// module chunks = 0